// Search filters (Phase 1 placeholder).
//
// Filter state is driven by URL query params and rendered server-side, so no JS
// is required yet. Phase 4 will sync filter controls with the URL and (optionally)
// fetch results/pagination via the secured AJAX endpoint.

module.exports = {};
